import React from 'react';
import { Table, Button, ButtonGroup, Label } from 'react-bootstrap';
import { toProperCase, getUser } from '../../utils/Common';
import { ThreeDots } from "react-loader-spinner";

export default function SharedUsersTable({
  moreUsers,
  handleUserClick,
  handleAddUserToBuilder,
  removeAllBuilderAccess,
  caps,
  isMobile,
  loadingMoreUsers
}) {
  const isSalesDemoUser = (user) => {
    return user.caps && user.caps.every(cap => cap.accessType === 'SALES_DEMO');
  };

  const currentUser = getUser();
  const filteredUsers = currentUser.role === 'ADMIN'
    ? moreUsers
    : moreUsers.filter(user => user.role !== 'ADMIN');

  if (loadingMoreUsers) {
    return (
      <div className="shared-users-loading">
        <ThreeDots color="#262626" height={30} width={30} />
      </div>
    );
  }

  if (filteredUsers.length === 0) {
    return null;
  }

  const getOverlappingCaps = (user) => {
    if (!user.caps || !caps) return [];
    return user.caps.map(userCap => {
      const matchingCap = caps.find(cap => cap.capId === userCap.capId);
      return matchingCap || null;
    }).filter(cap => cap !== null);
  };

  const formatLastLogin = (lastLogin) => {
    if (!lastLogin) return 'More than a month ago';
    return new Date(lastLogin).toLocaleDateString();
  };

  return (
    <div className={`shared-users-table-wrap ${isMobile ? 'shared-users-table-wrap--mobile' : ''}`}>
      <Table bordered condensed hover className="shared-users-table">
        <thead>
          <tr>
            <th>User Email</th>
            <th>Last Login</th>
            <th>{isMobile ? 'Access' : 'Camera Access'}</th>
            <th>{isMobile ? 'Actions' : 'Quick Actions'}</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.map(user => {
            const overlappingCount = getOverlappingCaps(user).length;
            return (
              <tr key={user.userId} className="shared-user-row">
                <td className="shared-user-cell-email" data-label="User">
                  <Button
                    bsStyle="default"
                    onClick={() => handleUserClick(user.userId)}
                    className="shared-user-button"
                  >
                    <div className="shared-user-info">
                      <div className="shared-user-email">{user.email}</div>
                      {user.firstName && (
                        <div className="shared-user-name">
                          {toProperCase(user.firstName)}{user.lastName ? ` ${toProperCase(user.lastName)}` : ''}
                        </div>
                      )}
                      {currentUser.role === 'ADMIN' && isSalesDemoUser(user) && (
                        <div className="shared-user-sales-demo-indicator">
                          <Label bsStyle="warning">SALES DEMO</Label>
                        </div>
                      )}
                      {currentUser.role === 'ADMIN' && user.role === 'ADMIN' && (
                        <div className="shared-user-admin-indicator">
                          <Label bsStyle="info">ADMIN</Label>
                        </div>
                      )}
                    </div>
                  </Button>
                </td>
                <td className="shared-user-cell-login" data-label="Last Login">
                  <span className="shared-user-last-login">{formatLastLogin(user.lastLogin)}</span>
                </td>
                <td className="shared-user-cell-access" data-label="Camera Access">
                  <span className="shared-user-access-count">
                    {overlappingCount} Camera{overlappingCount === 1 ? '' : 's'}
                  </span>
                </td>
                <td className="shared-user-action-cell shared-user-cell-actions" data-label="Actions">
                  {isMobile ? (
                    <div className="access-control-mobile-actions">
                      <Button
                        className="btn-brand-outline btn-compact"
                        onClick={() => handleAddUserToBuilder(user.userId)}
                      >
                        Add Employee
                      </Button>
                      <Button
                        className="btn-brand-outline btn-compact access-control-btn-danger"
                        onClick={() => removeAllBuilderAccess(user)}
                      >
                        Remove Access
                      </Button>
                    </div>
                  ) : (
                    <ButtonGroup className="shared-user-actions">
                      <Button
                        className="btn-brand-outline btn-compact"
                        onClick={() => handleAddUserToBuilder(user.userId)}
                      >
                        Mark as Employee
                      </Button>
                      <Button
                        className="btn-brand-outline btn-compact access-control-btn-danger"
                        onClick={() => removeAllBuilderAccess(user)}
                      >
                        Remove Access
                      </Button>
                    </ButtonGroup>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}
